import React from 'react';

// UserLayout is now a simple wrapper that just passes children through.
// The mobile container and bottom nav are handled by UserRouteWrapper in App.js.
// This component exists for backward compatibility — pages that import it still work.
const UserLayout = ({ children }) => {
  return <>{children}</>;
};

export default UserLayout;
